import React from 'react';

import htmlcss from './img/htmlCss.svg';
import nette from './img/nette.svg';
import javascript from './img/javascript.svg';
import react from './img/react.svg';
import vsCode from './img/vsCode.svg';
import github from './img/github.svg';
import uxUi from './img/uxUi.svg';
import figma from './img/figma.svg';
import photoshop from './img/photoshop.svg';
import php from './img/php.svg';
import canva from './img/canva2.svg';
import wordpress from './img/wordpress.svg';
import mssql from './img/MSSQL.svg';
import phpstorm from './img/phpstorm.svg';
import gitlab from './img/GitLab.svg';
import ai from './img/ai.svg';
import azure from './img/azure.svg';
import nextjs from './img/nextjs.svg';

const Skills = () => {
  return (
    <>
      <h2>What I use</h2>

      <div className="skills__grid">
        {skillsItems.map((item) => (
          <div className="skills__item">
            <img className="skills__icon" src={item.icon} alt={item.alt} />
            <h3 className="skills__title">{item.name}</h3>
          </div>
        ))}
      </div>
    </>
  );
};

const skillsItems = [
  {
    icon: `${nette}`,
    alt: 'Nette icon',
    name: 'Nette',
  },
  {
    icon: `${php}`,
    alt: 'PHP icon',
    name: 'PHP',
  },
  {
    icon: `${mssql}`,
    alt: 'MSSQL icon',
    name: 'MSSQL',
  },
  {
    icon: `${phpstorm}`,
    alt: 'PHP Storm icon',
    name: 'PHP Storm',
  },
  {
    icon: `${gitlab}`,
    alt: 'GitLab icon',
    name: 'GitLab',
  },
  {
    icon: `${azure}`,
    alt: 'Azure icon',
    name: 'Azure',
  },

  {
    icon: `${react}`,
    alt: 'React icon',
    name: 'React',
  },
  {
    icon: `${nextjs}`,
    alt: 'Next.js icon',
    name: 'Next.js',
  },
  {
    icon: `${javascript}`,
    alt: 'JavaScript icon',
    name: 'JavaScript',
  },
  {
    icon: `${vsCode}`,
    alt: 'VS Code icon',
    name: 'VS Code',
  },
  {
    icon: `${github}`,
    alt: 'GitHub icon',
    name: 'GitHub',
  },
  {
    icon: `${ai}`,
    alt: 'AI icon',
    name: 'AI',
  },
  {
    icon: `${uxUi}`,
    alt: 'UX UI icon',
  },
  {
    icon: `${figma}`,
    alt: 'Figma icon,',
    name: 'Figma',
  },
  {
    icon: `${photoshop}`,
    alt: 'Photoshop icon',
    name: 'Photoshop',
  },

  {
    icon: `${canva}`,
    alt: 'Canva icon',
    name: 'Canva',
  },
  {
    icon: `${htmlcss}`,
    alt: 'HTML and CSS icon',
    name: 'HTML a CSS',
  },
  {
    icon: `${wordpress}`,
    alt: 'WordPress icon',
    name: 'WordPress',
  },
];

export default Skills;
